<template>
  <div class="p-field">
    <label v-if="labelShown" :for="id">
      {{ label }}
      <span class="text-danger" v-if="isRequired"> * </span>
    </label>
    <div class="p-input-icon-right">
      <i :class="iconClass" />
      <Password
        :id="id"
        :readonly="readonly"
        :disabled="disabled"
        :value="value"
        :placeholder="placeholder"
        :autofocus="autofocus"
        :inputClass="[
          { 'p-invalid': validate.$error },
          inputClass,
          'form-control',
        ]"
        :toggleMask="toggleMask"
        :feedback="feedback"
        v-model="inputValue"
      />
    </div>
    <BaseFormMessage
      :validate="validate"
      :label="label"
      :baseErrorClass="baseErrorClass"
    />
  </div>
</template>

<script>
import Password from "primevue/password";

export default {
  components: {
    Password,
  },
  props: {
    isRequired: {
      type: Boolean,
      default: false,
    },
    //Password label
    label: {
      type: String,
    },
    // Password reactive value
    value: {
      type: String,
    },
    id: {
      type: String,
      default: "",
    },
    // Password reactive value
    validate: Object,
    // Password placeholder
    placeholder: String,
    // Password readonly state
    readonly: Boolean,
    // Password disabled state
    disabled: Boolean,
    // Password submitted state
    submitted: Boolean,
    // Password autofocus state
    autofocus: Boolean,
    //Password toggle mask
    toggleMask: Boolean,
    //Password feedback
    feedback: Boolean,
    //Password icon class
    iconClass: {
      type: String,
    },
    inputClass: {
      type: String,
      required: false,
    },
    labelShown: {
      type: Boolean,
      default: false,
    },
    baseErrorClass: {
      type: String,
      required: false,
    },
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      // setter
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
